import brand from '@helpers/brand';
import { m } from 'framer-motion';
import styled, { createGlobalStyle } from 'styled-components';
const GlobalStyles = createGlobalStyle `
  :root {
    --headerMessageHeight: 55px;
  }
`;
const Wrapper = styled.div `
  height: var(--headerMessageHeight, 0px);
  position: relative;
  overflow: hidden;
`;
const Container = styled(m.section) `
  --bgColor: ${brand.beige};
  --fgColor: ${brand.greyDark};
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: var(--bgColor);
  color: var(--fgColor);
`;
const Inner = styled.span `
  display: flex;
  width: 100%;
  place-items: center;
  height: var(--headerMessageHeight, 0px);
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;

  &.focus-ring {
    outline: auto;
    outline-offset: -3px;
    outline-color: ${brand.greyDark};
    outline-width: 2px;
  }
`;
const MessageBannerStyles = {
    Container,
    GlobalStyles,
    Inner,
    Wrapper,
};
export default MessageBannerStyles;
